import React from 'react';
import { isCredit } from '../types';

interface ITransactionTypeCellProps {
  amountCents: number; // Derive type from amount sign
}

export const TransactionTypeCell: React.FC<ITransactionTypeCellProps> = ({ amountCents }) => {
  const credit = isCredit(amountCents);

  return (
    <span className="inline-flex items-center gap-[5px]">
      <span
        className={`w-5 h-5 flex items-center justify-center rounded text-black ${
          credit ? 'bg-green-40' : 'bg-red-25'
        }`}
      >
        {credit ? '+' : '-'}
      </span>
      <span className="text-black">{credit ? 'Credit' : 'Debit'}</span>
    </span>
  );
};
